import { parsePublicDailyReport, publicDailyReportError } from "./public-daily-report-response";

export async function readPublicDailyReport(token: string, signal: AbortSignal) {
  const response = await fetch(`/api/production/reports/daily-snapshots/public/${encodeURIComponent(token)}`, {signal, cache: "no-store"});
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) throw new Error(publicDailyReportError(body));
  return parsePublicDailyReport(body);
}
